import React from 'react'
import { compose } from 'recompose'
import Canvas from 'components/Canvas'
import {
  Paper,
  RaisedButton,
  ToolbarGroup,
  Toolbar,
} from 'material-ui';
import { withCanvas } from 'store/canvas/withPaint'
import FormInput from 'components/forms/bases/FormInput'
import LanguageSwitcher from 'components/switches/LanguageSwitcher'
import { updateObject } from 'helpers/objectHelpers'
import { connect } from 'react-redux';
import { selectStoreId } from 'store/preferences/selectors'
import { writeData } from 'firebase/functions'
import styled from 'styled-components'

const StyledToolbar = styled(Toolbar)`
  height: 75px !important;
  z-index: 1080;
  top: 0;
  position: sticky;
  box-shadow: 1px 2px 5px 0 rgba(0, 0, 0, 0.2);
`

const PageController = compose(
  withCanvas(),
  connect((state) => ({ storeId: selectStoreId(state) })),
)(
  ({
    page,
    onChange,
    canvas,
    onSave,
    saveStatus,
    clearIsElementChange,
    storeId,
    openCanvasPreviewer,
  }) => {
    const handleSave = (bluePrint) => {
      // todo this is only for demo!!!
      writeData(storeId, 'demo', bluePrint)
      // console.log('onSave',onSave)
      return onSave(bluePrint).then(() => clearIsElementChange())
    }
    const handleUpdate = (val, key) => {
      return onChange(updateObject(page, { [key]: val }))
    }
    return (
      <div style={{ paddingRight: 350 }}>
        <Paper style={{ margin: 10 }}>
          <StyledToolbar>
            <ToolbarGroup>
              <FormInput
                label="Page Name"
                value={page.name || ''}
                onChange={(val) => handleUpdate(val, 'name')}
              />
            </ToolbarGroup>
            <ToolbarGroup>
              <LanguageSwitcher />
              <RaisedButton
                label={'Preview'}
                secondary
                onTouchTap={openCanvasPreviewer}
              />
              <RaisedButton
                label={saveStatus.isRequest ? 'Saving...' : 'Save'}
                primary={false}
                onTouchTap={() => handleSave({ ...page, ...canvas })}
              />
            </ToolbarGroup>
          </StyledToolbar>
          <Canvas />
        </Paper>
      </div>
    )
  }
)

export default PageController;


// WEBPACK FOOTER //
// ./src/pages/CustomPages/children/PageController.js